var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 98,
    viewBox: "0 0 160 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 158.5,
    height: 95.5667,
    rx: 11.25,
    fill: "#59B3C6",
    fillOpacity: 0.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 29,
    width: 160,
    height: 40,
    fill: "#59B3C6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 158.5,
    height: 95.5667,
    rx: 11.25,
    stroke: "#59B3C6",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBar);
export default __webpack_public_path__ + "static/media/chatBar.7915698f19177e2e1ac17f17f1165363.svg";
export { ForwardRef as ReactComponent };